import { render } from "./PlayButtonComponent.vue?vue&type=template&id=fc4f0ef0&scoped=true"
import script from "./PlayButtonComponent.vue?vue&type=script&lang=ts"
export * from "./PlayButtonComponent.vue?vue&type=script&lang=ts"

import "./PlayButtonComponent.vue?vue&type=style&index=0&id=fc4f0ef0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fc4f0ef0"

export default script